// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"297":"2e4537bf","510":"2e4537bf","656":"2e4537bf"}[chunkId] + ".chunk.css";
};